import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { SearchIcon, FilterIcon, ShoppingCartIcon, HeartIcon, StarIcon, TagIcon, TruckIcon, ShieldIcon, CheckIcon } from 'lucide-react';
export const Marketplace: React.FC = () => {
  return <div data-id="element-1085">
      <div className="flex justify-between items-center mb-6" data-id="element-1086">
        <h1 className="text-2xl font-bold text-navy" data-id="element-1087">Marketplace</h1>
        <Button variant="primary" icon={<ShoppingCartIcon size={16} data-id="element-1089" />} data-id="element-1088">
          Cart (3)
        </Button>
      </div>
      <div className="mb-6" data-id="element-1090">
        <div className="relative mb-4" data-id="element-1091">
          <input type="text" placeholder="Search products, brands, or categories..." className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-1092" />
          <SearchIcon size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1093" />
        </div>
        <div className="flex gap-2 overflow-x-auto pb-2 hide-scrollbar" data-id="element-1094">
          <Button variant="outline" size="sm" data-id="element-1095">
            All
          </Button>
          <Button variant="primary" size="sm" data-id="element-1096">
            Equipment
          </Button>
          <Button variant="outline" size="sm" data-id="element-1097">
            Wetsuits
          </Button>
          <Button variant="outline" size="sm" data-id="element-1098">
            Dive Computers
          </Button>
          <Button variant="outline" size="sm" data-id="element-1099">
            Cameras
          </Button>
          <Button variant="outline" size="sm" data-id="element-1100">
            Accessories
          </Button>
          <Button variant="outline" size="sm" icon={<FilterIcon size={14} data-id="element-1102" />} data-id="element-1101">
            Filter
          </Button>
        </div>
      </div>
      <div className="mb-6" data-id="element-1103">
        <Card className="bg-secondary/10 border border-secondary/20" data-id="element-1104">
          <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-1105">
            <div className="md:w-1/4" data-id="element-1106">
              <img src="https://images.unsplash.com/photo-1582749990332-9fc59f6df9d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80" alt="Sale" className="rounded-lg" data-id="element-1107" />
            </div>
            <div className="md:w-3/4 text-center md:text-left" data-id="element-1108">
              <Badge variant="secondary" className="mb-2" data-id="element-1109">
                Limited Time
              </Badge>
              <h2 className="text-xl font-bold mb-2" data-id="element-1110">Summer Dive Sale</h2>
              <p className="text-gray-700 mb-3" data-id="element-1111">
                Get up to 30% off on selected dive equipment and accessories.
                Perfect time to upgrade your gear for the summer diving season!
              </p>
              <Button variant="secondary" data-id="element-1112">Shop the Sale</Button>
            </div>
          </div>
        </Card>
      </div>
      <h2 className="font-semibold text-lg mb-4" data-id="element-1113">Featured Products</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8" data-id="element-1114">
        <Card className="flex flex-col h-full" data-id="element-1115">
          <div className="relative" data-id="element-1116">
            <img src="https://images.unsplash.com/photo-1582749990332-9fc59f6df9d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Dive Computer" className="w-full h-48 object-cover rounded-t-lg" data-id="element-1117" />
            <button className="absolute top-2 right-2 p-1.5 bg-white rounded-full text-gray-500 hover:text-primary" data-id="element-1118">
              <HeartIcon size={18} data-id="element-1119" />
            </button>
            <Badge variant="secondary" className="absolute top-2 left-2" data-id="element-1120">
              New
            </Badge>
          </div>
          <div className="p-4 flex-1 flex flex-col" data-id="element-1121">
            <div className="mb-2" data-id="element-1122">
              <p className="text-sm text-gray-500" data-id="element-1123">Dive Computers</p>
              <h3 className="font-semibold" data-id="element-1124">Garmin Descent G1</h3>
            </div>
            <div className="flex items-center mb-3" data-id="element-1125">
              <div className="flex text-yellow-400" data-id="element-1126">
                <StarIcon size={14} fill="currentColor" data-id="element-1127" />
                <StarIcon size={14} fill="currentColor" data-id="element-1128" />
                <StarIcon size={14} fill="currentColor" data-id="element-1129" />
                <StarIcon size={14} fill="currentColor" data-id="element-1130" />
                <StarIcon size={14} fill="currentColor" data-id="element-1131" />
              </div>
              <span className="text-xs text-gray-500 ml-1" data-id="element-1132">(42 reviews)</span>
            </div>
            <div className="flex items-center justify-between mb-3 mt-auto" data-id="element-1133">
              <p className="font-bold text-lg" data-id="element-1134">$499.99</p>
              <p className="text-sm text-gray-500 line-through" data-id="element-1135">$549.99</p>
            </div>
            <Button variant="primary" fullWidth icon={<ShoppingCartIcon size={16} data-id="element-1137" />} data-id="element-1136">
              Add to Cart
            </Button>
          </div>
        </Card>
        <Card className="flex flex-col h-full" data-id="element-1138">
          <div className="relative" data-id="element-1139">
            <img src="https://images.unsplash.com/photo-1544551763-92ab472cad5d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Wetsuit" className="w-full h-48 object-cover rounded-t-lg" data-id="element-1140" />
            <button className="absolute top-2 right-2 p-1.5 bg-white rounded-full text-gray-500 hover:text-primary" data-id="element-1141">
              <HeartIcon size={18} data-id="element-1142" />
            </button>
          </div>
          <div className="p-4 flex-1 flex flex-col" data-id="element-1143">
            <div className="mb-2" data-id="element-1144">
              <p className="text-sm text-gray-500" data-id="element-1145">Wetsuits</p>
              <h3 className="font-semibold" data-id="element-1146">Mares Flexa 5mm Wetsuit</h3>
            </div>
            <div className="flex items-center mb-3" data-id="element-1147">
              <div className="flex text-yellow-400" data-id="element-1148">
                <StarIcon size={14} fill="currentColor" data-id="element-1149" />
                <StarIcon size={14} fill="currentColor" data-id="element-1150" />
                <StarIcon size={14} fill="currentColor" data-id="element-1151" />
                <StarIcon size={14} fill="currentColor" data-id="element-1152" />
                <StarIcon size={14} data-id="element-1153" />
              </div>
              <span className="text-xs text-gray-500 ml-1" data-id="element-1154">(28 reviews)</span>
            </div>
            <div className="flex items-center justify-between mb-3 mt-auto" data-id="element-1155">
              <p className="font-bold text-lg" data-id="element-1156">$249.99</p>
            </div>
            <Button variant="primary" fullWidth icon={<ShoppingCartIcon size={16} data-id="element-1158" />} data-id="element-1157">
              Add to Cart
            </Button>
          </div>
        </Card>
        <Card className="flex flex-col h-full" data-id="element-1159">
          <div className="relative" data-id="element-1160">
            <img src="https://images.unsplash.com/photo-1586523969132-bf3a0e8d1d9c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Camera" className="w-full h-48 object-cover rounded-t-lg" data-id="element-1161" />
            <button className="absolute top-2 right-2 p-1.5 bg-white rounded-full text-gray-500 hover:text-primary" data-id="element-1162">
              <HeartIcon size={18} data-id="element-1163" />
            </button>
            <Badge variant="warning" className="absolute top-2 left-2" data-id="element-1164">
              Last One
            </Badge>
          </div>
          <div className="p-4 flex-1 flex flex-col" data-id="element-1165">
            <div className="mb-2" data-id="element-1166">
              <p className="text-sm text-gray-500" data-id="element-1167">Underwater Cameras</p>
              <h3 className="font-semibold" data-id="element-1168">Olympus TG-6 Underwater Camera</h3>
            </div>
            <div className="flex items-center mb-3" data-id="element-1169">
              <div className="flex text-yellow-400" data-id="element-1170">
                <StarIcon size={14} fill="currentColor" data-id="element-1171" />
                <StarIcon size={14} fill="currentColor" data-id="element-1172" />
                <StarIcon size={14} fill="currentColor" data-id="element-1173" />
                <StarIcon size={14} fill="currentColor" data-id="element-1174" />
                <StarIcon size={14} fill="currentColor" data-id="element-1175" />
              </div>
              <span className="text-xs text-gray-500 ml-1" data-id="element-1176">(56 reviews)</span>
            </div>
            <div className="flex items-center justify-between mb-3 mt-auto" data-id="element-1177">
              <p className="font-bold text-lg" data-id="element-1178">$429.99</p>
              <p className="text-sm text-gray-500 line-through" data-id="element-1179">$479.99</p>
            </div>
            <Button variant="primary" fullWidth icon={<ShoppingCartIcon size={16} data-id="element-1181" />} data-id="element-1180">
              Add to Cart
            </Button>
          </div>
        </Card>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-1182">
        <Card className="flex items-center gap-3 p-4" data-id="element-1183">
          <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-1184">
            <TruckIcon size={24} data-id="element-1185" />
          </div>
          <div data-id="element-1186">
            <h3 className="font-medium" data-id="element-1187">Free Shipping</h3>
            <p className="text-sm text-gray-600" data-id="element-1188">On orders over $100</p>
          </div>
        </Card>
        <Card className="flex items-center gap-3 p-4" data-id="element-1189">
          <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-1190">
            <ShieldIcon size={24} data-id="element-1191" />
          </div>
          <div data-id="element-1192">
            <h3 className="font-medium" data-id="element-1193">Warranty</h3>
            <p className="text-sm text-gray-600" data-id="element-1194">
              1-year manufacturer warranty
            </p>
          </div>
        </Card>
        <Card className="flex items-center gap-3 p-4" data-id="element-1195">
          <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-1196">
            <TagIcon size={24} data-id="element-1197" />
          </div>
          <div data-id="element-1198">
            <h3 className="font-medium" data-id="element-1199">Price Match</h3>
            <p className="text-sm text-gray-600" data-id="element-1200">
              We match any competitor price
            </p>
          </div>
        </Card>
      </div>
      <h2 className="font-semibold text-lg mb-4" data-id="element-1201">Popular Categories</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-1202">
        <div className="relative rounded-lg overflow-hidden group" data-id="element-1203">
          <img src="https://images.unsplash.com/photo-1582749990332-9fc59f6df9d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Dive Computers" className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1204" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-3" data-id="element-1205">
            <h3 className="text-white font-medium" data-id="element-1206">Dive Computers</h3>
          </div>
        </div>
        <div className="relative rounded-lg overflow-hidden group" data-id="element-1207">
          <img src="https://images.unsplash.com/photo-1544551763-92ab472cad5d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Wetsuits" className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1208" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-3" data-id="element-1209">
            <h3 className="text-white font-medium" data-id="element-1210">Wetsuits</h3>
          </div>
        </div>
        <div className="relative rounded-lg overflow-hidden group" data-id="element-1211">
          <img src="https://images.unsplash.com/photo-1586523969132-bf3a0e8d1d9c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Cameras" className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1212" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-3" data-id="element-1213">
            <h3 className="text-white font-medium" data-id="element-1214">Cameras</h3>
          </div>
        </div>
        <div className="relative rounded-lg overflow-hidden group" data-id="element-1215">
          <img src="https://images.unsplash.com/photo-1621507792677-afd35f4a5e4c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Accessories" className="w-full h-32 object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1216" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-3" data-id="element-1217">
            <h3 className="text-white font-medium" data-id="element-1218">Accessories</h3>
          </div>
        </div>
      </div>
      <Card data-id="element-1219">
        <h2 className="font-semibold mb-4" data-id="element-1220">Recently Viewed</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1221">
          <div className="flex gap-3" data-id="element-1222">
            <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden" data-id="element-1223">
              <img src="https://images.unsplash.com/photo-1582749990332-9fc59f6df9d1?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Dive Computer" className="w-full h-full object-cover" data-id="element-1224" />
            </div>
            <div data-id="element-1225">
              <h3 className="text-sm font-medium" data-id="element-1226">Garmin Descent G1</h3>
              <p className="text-xs text-gray-500" data-id="element-1227">Dive Computer</p>
              <p className="text-sm font-bold mt-1" data-id="element-1228">$499.99</p>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-1229">
            <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden" data-id="element-1230">
              <img src="https://images.unsplash.com/photo-1544551763-92ab472cad5d?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Wetsuit" className="w-full h-full object-cover" data-id="element-1231" />
            </div>
            <div data-id="element-1232">
              <h3 className="text-sm font-medium" data-id="element-1233">Mares Flexa 5mm</h3>
              <p className="text-xs text-gray-500" data-id="element-1234">Wetsuit</p>
              <p className="text-sm font-bold mt-1" data-id="element-1235">$249.99</p>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-1236">
            <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden" data-id="element-1237">
              <img src="https://images.unsplash.com/photo-1586523969132-bf3a0e8d1d9c?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Camera" className="w-full h-full object-cover" data-id="element-1238" />
            </div>
            <div data-id="element-1239">
              <h3 className="text-sm font-medium" data-id="element-1240">Olympus TG-6</h3>
              <p className="text-xs text-gray-500" data-id="element-1241">Camera</p>
              <p className="text-sm font-bold mt-1" data-id="element-1242">$429.99</p>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-1243">
            <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden" data-id="element-1244">
              <img src="https://images.unsplash.com/photo-1621507792677-afd35f4a5e4c?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Mask" className="w-full h-full object-cover" data-id="element-1245" />
            </div>
            <div data-id="element-1246">
              <h3 className="text-sm font-medium" data-id="element-1247">Scubapro Mask</h3>
              <p className="text-xs text-gray-500" data-id="element-1248">Mask</p>
              <p className="text-sm font-bold mt-1" data-id="element-1249">$89.99</p>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};